import OutputKeepAwakeSwitch from './OutputKeepAwakeSwitch'

export default OutputKeepAwakeSwitch
